export const InteractionStatus = {
    FOCUSED: 'focused',
    HOVERED: 'hovered',
    RESTFUL: 'restful',
};
